import { CSSProperties } from "react";

export const layoutStyles: CSSProperties = {
  /* background: `radial-gradient(50% 50% at 50% 50%, #6813CB 0%, #2A2A42 100%)`, */
  background: `radial-gradient(50% 50% at 50% 50%, #00bbb4 0%, #2a4141 100%)`,
  backgroundSize: "cover",
};

export const titleStyles: CSSProperties = {
  textAlign: "center",
  fontSize: "24px",
  letterSpacing: "-0.04em",
  marginBottom: "24px",
  overflowWrap: "break-word",
  hyphens: "manual",
  textOverflow: "unset",
  whiteSpace: "pre-wrap",
};
